import { render, staticRenderFns } from "./NeedApprovalRow.vue?vue&type=template&id=440c44de"
import script from "./NeedApprovalRow.vue?vue&type=script&lang=js"
export * from "./NeedApprovalRow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports